import { createAction, props } from '@ngrx/store';
import { SubscriptionStatusResponse } from '../../interfaces/stripe/stripe-interface';

// Load subscription status actions
export const loadSubscriptionStatus = createAction('[Subscription] Load Subscription Status');

export const loadSubscriptionStatusSuccess = createAction(
  '[Subscription] Load Subscription Status Success',
  props<{ subscription: SubscriptionStatusResponse | null }>()
);

export const loadSubscriptionStatusFailure = createAction('[Subscription] Load Subscription Status Failure', props<{ error: string }>());

// Clear subscription (on logout)
export const clearSubscription = createAction('[Subscription] Clear Subscription');

// Control automatic loading (used to pause auto-load during signup)
export const blockSubscriptionAutoLoad = createAction('[Subscription] Block Auto Load');
export const unblockSubscriptionAutoLoad = createAction('[Subscription] Unblock Auto Load');
